export default "__VITE_ASSET__1120fb67__"